import type { AuthContextType } from '@context/auth.context';
import type { OrganizationSettings } from '@interfaces/organization-settings';
import { apiRequest, isResponse } from '@services/fetcher';
import type { LoaderFunction } from 'react-router-dom';

export const loader = (auth: AuthContextType) =>
  (async ({ request }) => {
    const response = await apiRequest<OrganizationSettings>(
      `${import.meta.env.VITE_API_URL}/manage/organization/settings`,
      auth,
      {
        signal: request.signal,
      },
    );

    if (isResponse(response)) {
      return {
        status: response.status,
        statusText: response.statusText,
      } as Response;
    }

    if (response instanceof Error) {
      throw response;
    }

    return response;
  }) satisfies LoaderFunction;
